export default __webpack_public_path__ + "static/media/mojito-bottle-svg.bfaea040.svg";